// prettier-ignore
export const SocketActionTypes = {
  SET_IS_CONNECTED: 'SET_IS_CONNECTED',
  SET_RE_CONNECTED: 'SET_RE_CONNECTED',
  SET_PARTNER_CONFIGS: 'SET_PARTNER_CONFIGS',
  SET_IS_JACKPOT_CONNECTED: 'SET_IS_JACKPOT_CONNECTED'
};
